import { useEndpointFetch } from '../network/useEndpointFetch';

export const useResendVerifyEmailFetch = () => {
  return useEndpointFetch('/im/user/email/resend-verify');
};
